import * as React from "react";
import { createInheritedProvider } from "../utils/create-inherited-provider";
import { FieldCellCheckbox } from '../elements/field-cell-checkbox';
import { FieldCellDateTime } from '../elements/field-cell-date-time';
import { FieldCellFile } from '../elements/field-cell-file';
import { FieldCellImage } from '../elements/field-cell-image';
import { FieldCellLinked } from '../elements/field-cell-linked';
import { FieldCellLinkedMultiple } from '../elements/field-cell-linked-multiple';
import { FieldCellLongText } from '../elements/field-cell-long-text';
import { FieldCellNumber } from '../elements/field-cell-number';
import { FieldCellNumberInt } from '../elements/field-cell-number-int';
import { FieldCellText } from '../elements/field-cell-text';
import { FieldCellTextMultiple } from '../elements/field-cell-text-multiple';
/*
Defines the default set of entity field types to "cell" mappings.
A "Cell" is a generic component that can be used to display a field value in a data grid or other
context, where a concise representation of the value is needed.
*/
export var baseFieldCellComponentsDefinition = {
  text: FieldCellText,
  textMultiple: FieldCellTextMultiple,
  longText: FieldCellLongText,
  boolean: FieldCellCheckbox,
  int: FieldCellNumberInt,
  float: FieldCellNumber,
  date: FieldCellDateTime,
  image: FieldCellImage,
  file: FieldCellFile,
  linked: FieldCellLinked,
  linkedMultiple: FieldCellLinkedMultiple
  // linkedJunction: FormFieldLinkedJunction,
};
export var FieldCellComponentsContext = React.createContext(baseFieldCellComponentsDefinition);
export var FieldCellComponentsProvider = createInheritedProvider(FieldCellComponentsContext);